<div *ngIf="loader.show" class="loader-main">
  <div class="loader-div-wrapper">
    <div class="flex-shrink-0">
      <c-spinner color="primary"></c-spinner>
    </div>
    <span class="loader-text">{{ customMessage || message }}...</span>
  </div>
</div>
